import { createContext } from "react";
const contextFavorite = createContext("");

export default contextFavorite;
